export enum ModuleTokens {
  Name = 'usersBase'
}
